/*
 *
 * CONVERSTAION MESSAGES constants
 *
 */

export const GET_CONVERSATION_MESSAGES_REQUEST_SENT = 'src/messages/GET_CONVERSATION_MESSAGES_REQUEST_SENT';
export const GET_CONVERSATION_MESSAGES_REQUEST_SUCCEED = 'src/messages/GET_CONVERSATION_MESSAGES_REQUEST_SUCCEED';
export const GET_CONVERSATION_MESSAGES_REQUEST_FAILED = 'src/messages/GET_CONVERSATION_MESSAGES_REQUEST_FAILED';

export const SEND_MESSAGE_REQUEST_SENT = 'src/messages/SEND_MESSAGE_REQUEST_SENT';
export const SEND_MESSAGE_REQUEST_SUCCEED = 'src/messages/SEND_MESSAGE_REQUEST_SUCCEED';
export const SEND_MESSAGE_REQUEST_FAILED = 'src/messages/SEND_MESSAGE_REQUEST_FAILED';
